import { useQuery } from '@tanstack/react-query';
import { authApi, portalApi } from '../services/portalApi';
import { queryKeys } from './queryKeys';
import { useApiMutation } from '../hooks/useApiMutation';

export function useKnowledgeQuery() {
  return useQuery({ queryKey: queryKeys.knowledge, queryFn: portalApi.knowledge, select: (res) => res.docs || [] });
}

export function useSaveKnowledgeMutation() {
  return useApiMutation({
    mutationFn: ({ id, ...doc }) => (id ? portalApi.updateKnowledge(id, doc) : portalApi.createKnowledge(doc)),
    invalidate: [queryKeys.knowledge],
    success: 'Entry saved',
    error: 'Could not save the entry'
  });
}

export function useRemoveKnowledgeMutation() {
  return useApiMutation({
    mutationFn: (id) => portalApi.removeKnowledge(id),
    invalidate: [queryKeys.knowledge],
    success: 'Entry deleted',
    error: 'Could not delete the entry'
  });
}

export function useUploadKnowledgeMutation() {
  return useApiMutation({
    mutationFn: (file) => portalApi.uploadKnowledge(file),
    invalidate: [queryKeys.knowledge],
    success: 'PDF imported',
    error: 'Upload failed'
  });
}

export function useTestKnowledgeMutation() {
  return useApiMutation({ mutationFn: (query) => portalApi.testKnowledge(query), error: 'Test failed' });
}

export function useOnCallQuery() {
  return useQuery({ queryKey: queryKeys.onCall, queryFn: portalApi.onCall });
}

export function useUpdateOnCallMutation() {
  return useApiMutation({
    mutationFn: (onCall) => portalApi.updateOnCall(onCall),
    invalidate: [queryKeys.onCall],
    success: 'On-call saved',
    error: 'Could not save on-call'
  });
}

export function useBusinessHoursQuery() {
  return useQuery({ queryKey: queryKeys.businessHours, queryFn: portalApi.businessHours });
}

export function useUpdateBusinessHoursMutation() {
  return useApiMutation({
    mutationFn: (payload) => portalApi.updateBusinessHours(payload),
    invalidate: [queryKeys.businessHours],
    success: 'Business hours saved',
    error: 'Could not save business hours'
  });
}

export function useUpdateProfileMutation() {
  return useApiMutation({
    mutationFn: (payload) => authApi.updateProfile(payload),
    success: 'Profile saved',
    error: 'Could not save your profile'
  });
}
